import styled from '@emotion/styled'

export const StyledOutcomes = styled.div`


    display: flex;
    flex-direction: column;
    gap: 40px;

`